<template>
  <div
    class='theme-districts-dropdown__field-holder'
    :class="{
      'theme-input__field-holder--error': !!errors.has(newName),
      'theme-input__field-holder--is-disabled': disabled,
    }"
    data-vv-value-path='model'
    :data-vv-as='label'
  >
    <label class='theme-input__label' v-if='label'>
      {{ label }}
      <span v-if='isRequired' class='theme-input__label-asterisk'>*</span>
    </label>
    <div
      class='theme-districts-dropdown'
      :class="{
        'theme-districts-dropdown--green': green,
        'theme-districts-dropdown--blue': blue,
        'theme-districts-dropdown--focused': isFocused,
      }"
    >
      <input v-if='model.length == 0' type='hidden' :name='name' :value="''" :rules='rules'/>
      <div
        class='theme-districts-dropdown__tag'
        v-for='item in model'
        :key='item'
        @click='toggleItem(item)'
      >
        <input type='hidden' :name='name' :value='item' :rules='rules'/>
        <span class='location-name'>{{ item }}</span>
        <span class='icon-close location-close'></span>
      </div>
      <div class='theme-districts-dropdown__wrap'>
        <input
          v-model='phrase'
          class='theme-input theme-districts-dropdown__input'
          type='text'
          @keydown.enter.prevent='toggleItem(phrase)'
          :disabled='disabled'
          :placeholder='placeholder'
          @focus="isFocused = true"
          @blur="isFocused = false"
        />

        <span v-if="phrase" @click="clearPhrase" class="icon-clear theme-districts-dropdown__icon-clear"></span>
        <span v-if='errors.has(newName)' class='icon-warning theme-input__icon theme-input__icon-error'></span>
      </div>
    </div>

    <button 
      type="button" 
      @click.prvent='toggleItem(phrase)' 
      :class="[
        'theme-btn theme-btn--primary theme-btn--small mt-3 w-full md:w-auto',
         {'theme-btn--primary-disabled': !phrase}
      ]">
      {{ !model.includes(phrase) ? 'Add' : 'Remove' }}
    </button>

    <div class='theme-input__error-text' v-if='errors.has(newName)'>
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';
  import field from '../admin/mixins/field';

  export default {
    props: {
      value: {
        default() {
          return [];
        },
      },
      resolve: {
        default: (hit) => {
          return hit.name;
        },
        type: Function,
      },
      endpoint: {
        default: '/admin/autocomplete/locations',
        type: String,
      },
      base: {
        default: '',
        type: String,
      },
      initial: {
        default: '',
        type: String,
      },
      isRequired: {
        default: false,
        type: Boolean,
      },
      green: {
        default: false,
        type: Boolean,
      },
      blue: {
        default: false,
        type: Boolean,
      },
      placeholder: {
        default: '',
        type: String,
      },
      data: {
        default: [],
        type: Array,
      },
    },
    data() {
      return {
        isDirtyData: null,
        phrase: '',
        isFocused: false,
      };
    },
    methods: {
      toggleItem(item) {
        const index = this.model.findIndex((selected) => selected === item);
        if (index !== -1) {
          this.model.splice(index, 1);
        } else {
          this.model.push(item);
        }
        this.phrase = '';
      },
      clearPhrase() {
        this.phrase = '';
      }
    },
    mixins: [field],
    watch: {
      model(value) {
        if (!value) {
          this.phrase = null;
        }
        this.$emit('update', value);
        this.$emit('input', value);
      },
    },
    mounted() {
      if (this.data.length > 0 && !this.data.some((item) => item === null)) {
        this.model = this.data;
      }
    },
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/ThemeDistrictsDropdown.vue